import TopNavigation, {
  type TopNavigationProps,
} from "@cloudscape-design/components/top-navigation"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../contexts/AuthContext"
import { useMyAccess } from "../../hooks/queries/useMyAccess"
import { ROUTES } from "../../utils/constants"
import NotificationPopover from "./NotificationPopover"
import "./Header.css"

const ROLE_LABELS = {
  internal: "Data Acquisition Expert",
  external: "Vendor",
  none: "",
} as const

const Header = () => {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const { experience, pages: navItems } = useMyAccess()

  const displayName = user?.email || user?.principalId || ""

  const handleLogout = async () => {
    try {
      await logout()
      navigate(ROUTES.LOGIN)
    } catch (error) {
      console.error("Logout error:", error)
    }
  }

  const utilities: TopNavigationProps.Utility[] = []

  if (user?.isAuthenticated) {
    for (const item of navItems) {
      utilities.push({
        type: "button",
        text: item.text,
        href: item.href,
        onFollow: (e) => {
          e.preventDefault()
          navigate(item.href)
        },
      })
    }

    if (experience !== null) {
      utilities.push({
        type: "button",
        ariaLabel: "Notifications",
        iconSvg: <NotificationPopover />,
        disableUtilityCollapse: true,
      })
    }

    utilities.push({
      type: "menu-dropdown",
      text: displayName,
      description: ROLE_LABELS[experience ?? "none"],
      iconName: "user-profile",
      items: [{ id: "signout", text: "Sign Out" }],
      onItemClick: ({ detail }) => {
        if (detail.id === "signout") void handleLogout()
      },
    })
  } else {
    utilities.push({
      type: "button",
      text: "Sign In",
      href: ROUTES.LOGIN,
      onFollow: (e) => {
        e.preventDefault()
        navigate(ROUTES.LOGIN)
      },
    })
  }

  return (
    <div id="top-nav" className="header-sticky">
      <TopNavigation
        identity={{
          href: "/",
          title: "CDR",
          logo: { src: "/aws-logo-white.svg", alt: "AWS" },
          onFollow: (e) => {
            e.preventDefault()
            navigate("/")
          },
        }}
        utilities={utilities}
        i18nStrings={{
          overflowMenuTriggerText: "More",
          overflowMenuTitleText: "All",
        }}
      />
    </div>
  )
}

export default Header
